<template>
  <SiruiSearch
    ref="billApprovalFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules } from './index.js';
  import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'BillApprovalForm',
    data() {
      return {
        baseFormData: {
          approvalType: '',
          stockQuantity: null,
          safeStockQuantity: null,
          reason: null,
          outStockQuantity: null,
          canUseStockQuantity: null,
          approvalComment: null,
        },
        frozeReasonList: [],
        frozeReason: 0,
        approvalType: '',
        id: null,
        billNo: '',
        reason: '',
        isHideFrozeReason: true,
        idHideOutStockQuantity: true,
      };
    },
    mounted() {
      this.id = this.$route.query?.id;
      this.getBillNo(this.id);
      this.frozeReasonList = this.dictListMap.superviseBillFrozeReason;
      this.frozeReason = this.translateFrozeReason(this.baseFormData.reason);
    },
    computed: {
      formColumn() {
        return baseFormColumn(this);
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    methods: {
      // 获取表格数据
      async getTableData() {
        return await this.$refs.billApprovalFormRef.getValidateFormData();
      },
      async getBillNo(id) {
        this.isLoading = true;
        const detailData = await this.$axios.post(
          `${superviseBillApi.GET_BILL_DETAIL_BY_ID}/${id}`
        );
        this.isLoading = false;
        if (detailData.data.code == 0) {
          this.showWords(detailData.data.data.approvalType);
          this.billNo = detailData.data.data.billNo;
          this.initForm(this.billNo);
          this.frozeReason = detailData.data.data.frozeReason;
          this.baseFormData.reason = detailData.data.data.frozeReason;
          this.baseFormData.approvalType = this.translateApprovalTypeToNumber(
            detailData.data.data.approvalType
          );
          this.approvalType = this.translateApprovalType(this.baseFormData.approvalType);
        } else {
          console.error('获取数据失败');
        }
      },
      async initForm(billNo) {
        const { data } = await this.$axios.post(
          `${superviseBillApi.APPROVAL_QUERY_STOCK}/${billNo}`
        );
        if (data.code == 0) {
          this.baseFormData.canUseStockQuantity = data.data.canUseStockQuantity;
          this.baseFormData.outStockQuantity = data.data.outStockQuantity;
          this.baseFormData.safeStockQuantity = data.data.safeStockQuantity;
          this.baseFormData.stockQuantity = data.data.stockQuantity;
        }
      },
      // 翻译冻结原因
      translateFrozeReason(val) {
        return this.frozeReasonList.find((item) => item.value == parseInt(val))?.label;
      },
      // 翻译审批类型(英文->中文)
      translateApprovalType(val) {
        if (val == '01') {
          return '常规';
        } else if (val == '02') {
          return '手动冻结';
        } else if (val == '03') {
          return '解冻申请';
        } else if (val == '04') {
          return '解押申请';
        } else if (val == '05') {
          return '创建申请';
        }
      },
      // 翻译审批类型(英文->数值)
      translateApprovalTypeToNumber(val) {
        if (val == 'create') {
          return '05';
        } else if (val == 'froze') {
          return '02';
        } else if (val == 'unfroze') {
          return '03';
        } else if (val == 'release') {
          return '04';
        }
      },
      // 根据审批类型显示或隐藏相字段
      showWords(val) {
        if (val == 'froze') {
          this.isHideFrozeReason = false;
        } else if (val == 'release') {
          this.idHideOutStockQuantity = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-select {
    width: 250px;
  }
  .el-input {
    width: 250px;
  }
</style>
